import { render } from "./AnketaItem.vue?vue&type=template&id=1d798faa&scoped=true"
import script from "./AnketaItem.vue?vue&type=script&lang=js"
export * from "./AnketaItem.vue?vue&type=script&lang=js"

import "./AnketaItem.vue?vue&type=style&index=0&id=1d798faa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d798faa"]])

export default __exports__